import React from 'react';
import './SecurityFeatures.css';

const CheckListItem = ({ children }) => (
  <li className="security-feature-checklist-item">{children}</li>
);

function SecurityFeatures() {
  return (
    <section className="security-features-wrapper">
      <div className="security-features-container">
        <div className="security-features-intro">
          <h2 className="security-features-headline">
            Securing every conversation – human or AI, at global scale
          </h2>
          <p className="security-features-subheadline">
            When customer conversations drive your business, trust isn’t optional. Sendbird protects every interaction, whether human or AI, with enterprise-grade security, privacy, and performance, trusted by some of the world’s most security-conscious industries.
          </p>
        </div>

        <div className="security-features-list">
          {/* Card 1: Best in class internal security */}
          <div className="security-feature-block type-one">
            <div className="security-feature-block-content">
              <h3 className="security-feature-block-title">Best in class internal security</h3>
              <p className="security-feature-block-description">Sendbird uses an automation-first approach to implement advanced internal security measures.</p>
              <ul className="security-feature-checklist">
                <CheckListItem>FIDO2 MFA & device trust to prevent phishing</CheckListItem>
                <CheckListItem>Automated Detection & Response</CheckListItem>
                <CheckListItem>Automated Compliance</CheckListItem>
                <CheckListItem>DevSecOps approach</CheckListItem>
              </ul>
            </div>
          </div>

          {/* Card 2: Enterprise-grade reliability */}
          <div className="security-feature-block type-two">
             <div className="security-feature-block-content">
                <h3 className="security-feature-block-title">Enterprise-grade reliability & performance</h3>
                <p className="security-feature-block-description">Proven to perform at global scale, Sendbird powers 7 billion+ conversations every month—delivering high availability, low latency, and real-time responsiveness, even in mission-critical environments.</p>
                <ul className="security-feature-checklist">
                  <CheckListItem>Global infrastructure built for scale</CheckListItem>
                  <CheckListItem>Real-time monitoring and 24/7 incident response</CheckListItem>
                  <CheckListItem>Trusted by enterprises across regulated industries</CheckListItem>
                </ul>
             </div>
          </div>

          {/* Card 3: Advanced security features */}
          <div className="security-feature-block type-three">
            <div className="security-feature-image-container">
              <img src="https://sendbird.imgix.net/cms/Advanced-security-features-controls.png" alt="Advanced security features icon" />
            </div>
            <div className="security-feature-block-content">
              <h3 className="security-feature-block-title">Advanced security<br/>features & controls</h3>
              <p className="security-feature-block-description">Built-in security features give you full control over how you protect customer data—so you can align Sendbird to your internal policies and compliance needs.</p>
              <ul className="security-feature-checklist dark-checks">
                <CheckListItem>End-to-end encryption and TLS in transit</CheckListItem>
                <CheckListItem>Granular role-based access controls</CheckListItem>
                <CheckListItem>Full audit logs for visibility and control</CheckListItem>
              </ul>
            </div>
          </div>
          
          {/* Card 4: Data privacy & residency */}
          <div className="security-feature-block type-four">
            <div className="security-feature-block-content">
              <h3 className="security-feature-block-title">Data privacy & residency options</h3>
              <p className="security-feature-block-description">Maintain full control over where your data resides, how it’s stored, and who can access it—helping you meet regulatory and internal data governance requirements.</p>
              <ul className="security-feature-checklist">
                <CheckListItem>Regional hosting to support data residency needs</CheckListItem>
                <CheckListItem>Clear data ownership and processing transparency</CheckListItem>
                <CheckListItem>Flexible data retention settings aligned to your policy</CheckListItem>
              </ul>
            </div>
            <div className="security-feature-image-container">
              <img src="https://sendbird.imgix.net/cms/Frame-2043683313.png" alt="Data privacy and residency map" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SecurityFeatures;